import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../_common/carousel';
import Price from './price';

// Simple product card for display
const RecentProductCard = ({ product }) => (
  <div className="recent-product-card mx-1" style={{ border: '1px solid #eee' }}>
    <a 
      href={product.url} 
      className='d-flex flex-column h-100 px-2'
      aria-label={`View ${product.title} - ${product.themeTitle} - From ${product.unitPrices[0].price}`}
      role="link"
    >
      <div className="card-image thumbnail">
        <div className="product-image d-flex align-items-center">
          <img
            className="image-fluid m-auto"
            src={product.thumbnail}
            alt={product.title}
          />
        </div>
      </div>
      <div className="align-content-end card-body p-0">
        <div className="product-information d-flex flex-column text-left mb-3">
          <span>{product.themeTitle}</span>
          <span>{product.title}</span>
          <strong>
            <Price now={product.unitPrices[0].price} />
          </strong>
        </div>
      </div>
      <span className="btn btn-primary m-2 view-recent-product" aria-hidden="true">View Product</span>
    </a>
  </div>
);

RecentProductCard.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    themeTitle: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    thumbnail: PropTypes.string,
    unitPrices: PropTypes.arrayOf(
      PropTypes.shape({
        from: PropTypes.number.isRequired,
        price: PropTypes.number.isRequired,
      })
    ).isRequired,
  }).isRequired,
};

const slickSettings = {
  // generic settings
  arrows: true,
  infinite: true,
  speed: 300,
  dots: false,

  // xl - wide desktops
  slidesToShow: 5,
  slidesToScroll: 5,

  responsive: [
    {
      // lg - desktops
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
      },
    },
    {
      // md - tablets
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        dots: true,
      },
    },
    {
      // sm - new phones
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
      },
    },
    {
      // xs - old phones
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
      },
    },
  ],
};

const RecentProducts = ({ products, currentProductId, currentThemeTitle }) => {
  const recentProducts = () => {
    const excludedCurrent = products.filter(p => p.id !== currentProductId || p.themeTitle !== currentThemeTitle);

    return excludedCurrent.slice(0, 5).map((product) => (
      <RecentProductCard key={product.id} product={product} />
    ));
  }
  return (
    <div className="recent-products-list col-lg-9 col-12 mt-3 px-0">
      {products.length > 1 && <h3>Recently Viewed Products</h3>}
      <Carousel
        id={'recent-products-carousel'}
        slickSettings={slickSettings}
        responseMessage={null}>
        {recentProducts()}
      </Carousel>
    </div>
  );
}

RecentProducts.propTypes = {
  products: PropTypes.arrayOf(RecentProductCard.propTypes.product).isRequired,
  currentProductId: PropTypes.number,
  currentThemeTitle: PropTypes.string,
};

export default RecentProducts;